module.exports = __webpack_public_path__ + "img/docs.109b794f.svg";